import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/node_modules/react-grid-layout/css/styles.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/node_modules/react-resizable/css/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/components/global-page-wrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["RouteProvider"] */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/providers/route-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2326840661/src/seedkit-nextjs-frontend/src/styles/lexical.css");
